import { createNamedContext } from '@utils';
import { SelectedParticipant } from './interfaces';

export const SelectedParticipantContext = createNamedContext<SelectedParticipant.Context>(null, 'SelectedParticipant.Context');